var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShield = function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "shield_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.667 47.392 32 59.992l23.333-12.6V4H8.667zm7-36.556v31.286L32 50.812l16.333-8.69V10.836zm4.666 28.483V15.503h23.334v23.816L32 45.526z",
    clipRule: "evenodd"
  })));
};
export { SvgShield as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTguNjY2NjYgNDcuMzkxOEwzMS45OTk4IDU5Ljk5MThMNTUuMzMzMyA0Ny4zOTE4VjRIOC42NjY2NlY0Ny4zOTE4Wk0xNS42NjY3IDEwLjgzNTlWNDIuMTIyMkwzMiA1MC44MTIzTDQ4LjMzMzMgNDIuMTIyMlYxMC44MzU5SDE1LjY2NjdaTTIwLjMzMzMgMzkuMzE5VjE1LjUwMjZINDMuNjY2N1YzOS4zMTlMMzIgNDUuNTI2M0wyMC4zMzMzIDM5LjMxOVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";